export default {
	namespaced: true,
	state: {
		collapsed: false,
		section: '',
		title: ''
	},
	mutations: {
		setCollapsed: (state, isCollapsed) => {
			state.collapsed = isCollapsed;
		},
		setSection: (state, name) => {
			state.section = name;
		},
		setTitle: (state, title) => {
			state.title = title;
		}
	},
	actions: {},
	getters: {
		appBarCollapsed: state => state.collapsed,
		currentSection: state => state.section,
		currentTitle: state => state.title
	}
};
